import { useEffect, useState } from 'react';
import {
    FaSearch, FaCheckCircle, FaRegTimesCircle, FaProductHunt, FaRecycle,
    FaCloudDownloadAlt, FaInfoCircle
} from 'react-icons/fa';
import { BsFillSendFill } from 'react-icons/bs';
import { FaDownload } from 'react-icons/fa6';
import LoadingComponent from './../../widgets/LoadingComponent';
import { getData, getFileData } from '../../api/ApiRest';
import moment from 'moment';
import { NumericFormat } from 'react-number-format';
import AsyncSelect from 'react-select/async';
import DocumentoReEnvioCorreo from './DocumentoReEnvioCorreo';
import DocumentoEnviadoInfoDIAN from './DocumentoEnviadoInfoDIAN';
import { exportToExcel } from 'react-json-to-excel';
import { useSelector } from 'react-redux';
import {
    Box, Paper, Grid, TextField, MenuItem, Button, Typography,
    Breadcrumbs, Link, Chip, Tooltip,
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
    IconButton, Menu, MenuItem as MuiMenuItem
} from '@mui/material';
import { styled } from '@mui/material/styles';

const TIPO_DOCUMENTO_OPTIONS = [
    { value: 'null', label: 'TODOS' },
    { value: '1', label: 'Factura de Venta Nacional' },
    { value: '2', label: 'Factura de Exportación' },
    { value: '3', label: 'Factura de Contingencia' },
    { value: '4', label: 'Nota Crédito' },
    { value: '5', label: 'Nota Débito' },
    { value: '11', label: 'Documento Soporte Electrónico' },
    { value: '13', label: 'Nota de Ajuste al Documento Soporte Electrónico' },
    { value: '15', label: 'Documento equivalente P.O.S.' },
    { value: '25', label: 'Nota de Ajuste de tipo débito al Documento Equivalente' },
    { value: '26', label: 'Nota de Ajuste de tipo crédito al Documento Equivalente' },
];

const StyledHeaderCell = styled(TableCell)(() => ({
    backgroundColor: '#224B6A',
    color: '#fff',
    fontWeight: 'bold',
    fontSize: '0.78rem',
    whiteSpace: 'nowrap',
    padding: '10px 12px',
}));

const StyledRow = styled(TableRow)(({ index }) => ({
    backgroundColor: index % 2 === 0 ? '#fff' : '#f4f8fb',
    '&:hover': { backgroundColor: 'rgba(144, 203, 216, 0.25)' },
}));

const StyledCell = styled(TableCell)(() => ({
    fontSize: '0.78rem',
    padding: '8px 12px',
    borderColor: '#dee2e6',
}));

function DownloadMenu({ onDownload }) {
    const [anchor, setAnchor] = useState(null);
    return (
        <>
            <Tooltip title="Descargar">
                <IconButton size="small" onClick={e => setAnchor(e.currentTarget)}
                    sx={{ color: '#224B6A' }}>
                    <FaCloudDownloadAlt size={15} />
                </IconButton>
            </Tooltip>
            <Menu anchorEl={anchor} open={Boolean(anchor)} onClose={() => setAnchor(null)}
                PaperProps={{ sx: { minWidth: 100 } }}>
                {['PDF', 'XML', 'ZIP'].map(tipo => (
                    <MuiMenuItem key={tipo} dense onClick={() => { onDownload(tipo); setAnchor(null); }}
                        sx={{ fontSize: '0.82rem' }}>
                        {tipo}
                    </MuiMenuItem>
                ))}
            </Menu>
        </>
    );
}

function DocumentoEnviado() {
    const [loading, setLoading] = useState(false);
    const [dataBuscar, setDataBuscar] = useState({
        Prefijo: '',
        Numero: '',
        ClienteNit: '',
        EmisorId: '',
        Ambiente: '',
        TipoDocumentoid: 'null',
        EstadoDocumento: '1',
        Desde: moment(new Date(new Date(new Date().setHours(1)).setMinutes(0, 0))).format('yyyy-MM-DDTHH:mm'),
        Hasta: moment(new Date(new Date(new Date().setHours(23)).setMinutes(59, 0))).format('yyyy-MM-DDTHH:mm'),
        Cufe: ''
    });
    const [documents, setDocuments] = useState([]);
    const [adminTae, setAdminTae] = useState(false);
    const [modalReEnvio, setModalReEnvio] = useState(false);
    const [modalInfoEmision, setModalInfoEmision] = useState(false);
    const [documentSelect, setDocumentSelect] = useState({});

    const infoUser = useSelector((state) => state.auth);

    useEffect(() => {
        setAdminTae(infoUser.AdminTae === 'true');
    }, []);

    const set = (field) => (e) => setDataBuscar(prev => ({ ...prev, [field]: e.target.value }));

    const descargarExcel = async () => {
        await getData('api/Cliente/Document/DocumentsExcelGet', {
            Prefijo: dataBuscar.Prefijo,
            Number: dataBuscar.Numero,
            CompanyId_Emisior: dataBuscar.EmisorId,
            ClienteNit: dataBuscar.ClienteNit,
            Enviroment: dataBuscar.Ambiente,
            FechaDesde: dataBuscar.Desde,
            FechaHasta: dataBuscar.Hasta,
            TipoDocumentoId: dataBuscar.TipoDocumentoid,
            EstadoDocumento: dataBuscar.EstadoDocumento
        }, true).then(response => {
            if (response.status === true) exportToExcel(response.documents, 'DocumentosEnviados');
            setLoading(false);
        }, error => {
            alert('algo salio mal con la busqueda');
            console.log(error);
            setLoading(false);
        });
    };

    const buscarDocumentos = (event) => {
        event.preventDefault();
        setLoading(true);
        getData('api/Cliente/Document/DocumentsGet', {
            Prefijo: dataBuscar.Prefijo,
            Number: dataBuscar.Numero,
            CompanyId_Emisior: dataBuscar.EmisorId,
            ClienteNit: dataBuscar.ClienteNit,
            Enviroment: dataBuscar.Ambiente,
            FechaDesde: dataBuscar.Desde,
            FechaHasta: dataBuscar.Hasta,
            TipoDocumentoId: dataBuscar.TipoDocumentoid,
            EstadoDocumento: dataBuscar.EstadoDocumento,
            Cufe: dataBuscar.Cufe
        }, true).then(response => {
            if (response.status === true) setDocuments(response.documents);
            setLoading(false);
        }, error => {
            alert('algo salio mal con la busqueda');
            console.log(error);
            setLoading(false);
        });
    };

    const descargarArhivo = (Id = 0, Documento = '', Tipo = 'PDF') => {
        const endpoints = {
            PDF: { path: 'api/Cliente/Document/DocumentGetPDF', ext: '.pdf' },
            ZIP: { path: 'api/Cliente/Document/DocumentGetZip', ext: '.zip' },
            XML: { path: 'api/Cliente/Document/DocumentGetXml', ext: '.xml' },
        };
        const config = endpoints[Tipo];
        if (!config) { alert('Error de extension'); return; }

        setLoading(true);
        getFileData(config.path, { id: Id }).then(response => {
            const file = window.URL.createObjectURL(response);
            const a = document.createElement('a');
            document.body.appendChild(a);
            a.style = 'display: none';
            a.href = file;
            a.download = Documento + config.ext;
            a.click();
            window.URL.revokeObjectURL(file);
            a.remove();
            setLoading(false);
        }, error => {
            console.log(error);
            setLoading(false);
            alert('Algo mal al descargar');
        });
    };

    const companieSearchSelect2 = async (Param) => {
        return await getData('api/Configuracion/Company/Select2Company',
            { param: Param }, false).then(response => response.companies, () => []);
    };

    const inputSx = { '& .MuiInputBase-input': { fontSize: '0.82rem' }, '& .MuiInputLabel-root': { fontSize: '0.82rem' } };

    return (
        <Box sx={{ p: 2 }}>
            {/* Breadcrumb */}
            <Breadcrumbs sx={{ mb: 2, fontSize: '0.82rem' }}>
                <Link underline="hover" color="inherit" href="#">Empresas</Link>
                <Typography color="text.primary" fontSize="0.82rem">Facturas Envíos</Typography>
            </Breadcrumbs>

            {/* Panel de filtros */}
            <Paper elevation={2} sx={{ p: 2.5, mb: 2, borderRadius: 2 }} component="form" onSubmit={buscarDocumentos}>
                <Grid container spacing={1.5} alignItems="flex-end">

                    <Grid item xs={12} sm={6} md={3}>
                        <TextField label="Emisión Desde" type="datetime-local" fullWidth size="small"
                            required InputLabelProps={{ shrink: true }}
                            value={dataBuscar.Desde} onChange={set('Desde')} sx={inputSx} />
                    </Grid>

                    <Grid item xs={12} sm={6} md={3}>
                        <TextField label="Emisión Hasta" type="datetime-local" fullWidth size="small"
                            required InputLabelProps={{ shrink: true }}
                            value={dataBuscar.Hasta} onChange={set('Hasta')} sx={inputSx} />
                    </Grid>

                    <Grid item xs={12} sm={6} md={6}>
                        <TextField label="Tipo Documento" select fullWidth size="small"
                            value={dataBuscar.TipoDocumentoid} onChange={set('TipoDocumentoid')} sx={inputSx}>
                            {TIPO_DOCUMENTO_OPTIONS.map(o => (
                                <MenuItem key={o.value} value={o.value} sx={{ fontSize: '0.82rem' }}>{o.label}</MenuItem>
                            ))}
                        </TextField>
                    </Grid>

                    <Grid item xs={6} sm={3} md={2}>
                        <TextField label="Etapa" select fullWidth size="small"
                            value={dataBuscar.Ambiente} onChange={set('Ambiente')} sx={inputSx}>
                            <MenuItem value="" sx={{ fontSize: '0.82rem' }}>TODOS</MenuItem>
                            <MenuItem value="2" sx={{ fontSize: '0.82rem' }}>PRUEBA</MenuItem>
                            <MenuItem value="1" sx={{ fontSize: '0.82rem' }}>PRODUCCIÓN</MenuItem>
                        </TextField>
                    </Grid>

                    <Grid item xs={6} sm={3} md={2}>
                        <TextField label="Estado" select fullWidth size="small"
                            value={dataBuscar.EstadoDocumento} onChange={set('EstadoDocumento')} sx={inputSx}>
                            <MenuItem value="-9" sx={{ fontSize: '0.82rem' }}>Todos</MenuItem>
                            <MenuItem value="1" sx={{ fontSize: '0.82rem' }}>Aceptado</MenuItem>
                            <MenuItem value="0" sx={{ fontSize: '0.82rem' }}>Rechazado</MenuItem>
                        </TextField>
                    </Grid>

                    <Grid item xs={6} sm={3} md={2}>
                        <TextField label="Prefijo" fullWidth size="small" autoComplete="off"
                            value={dataBuscar.Prefijo} onChange={set('Prefijo')} sx={inputSx} />
                    </Grid>

                    <Grid item xs={6} sm={3} md={2}>
                        <TextField label="Consecutivo" type="number" fullWidth size="small" autoComplete="off"
                            value={dataBuscar.Numero} onChange={set('Numero')} sx={inputSx} />
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                        <TextField label="Cliente Identificación" type="number" fullWidth size="small" autoComplete="off"
                            value={dataBuscar.ClienteNit} onChange={set('ClienteNit')} sx={inputSx} />
                    </Grid>

                    <Grid item xs={12} sm={6} md={6}>
                        <TextField label="CUFE" fullWidth size="small" autoComplete="off"
                            value={dataBuscar.Cufe} onChange={set('Cufe')} sx={inputSx} />
                    </Grid>

                    {adminTae && (
                        <Grid item xs={12} md={5}>
                            <Typography variant="caption" color="text.secondary" sx={{ mb: 0.5, display: 'block' }}>
                                Empresa Emisora
                            </Typography>
                            <AsyncSelect
                                cacheOptions defaultOptions
                                menuPosition="fixed"
                                noOptionsMessage={() => 'Escriba para iniciar la búsqueda'}
                                placeholder="Empresa Emisora"
                                isClearable
                                loadOptions={companieSearchSelect2}
                                onChange={value => setDataBuscar(prev => ({
                                    ...prev,
                                    EmisorId: value ? value.value : null
                                }))}
                                styles={{ control: base => ({ ...base, fontSize: '0.82rem', minHeight: 38 }) }}
                            />
                        </Grid>
                    )}

                    {/* Botones */}
                    <Grid item xs={12}>
                        <Box sx={{ display: 'flex', gap: 1 }}>
                            <Button type="submit" variant="contained" size="small" startIcon={<FaSearch size={12} />}
                                sx={{ background: '#224B6A', '&:hover': { background: '#1a3a54' }, fontSize: '0.78rem' }}>
                                Buscar
                            </Button>
                            <Button type="button" variant="outlined" size="small" startIcon={<FaDownload size={12} />}
                                onClick={descargarExcel}
                                sx={{ fontSize: '0.78rem', borderColor: '#224B6A', color: '#224B6A' }}>
                                Excel
                            </Button>
                        </Box>
                    </Grid>

                </Grid>
            </Paper>

            <LoadingComponent Loading={loading} />

            {/* Tabla */}
            <TableContainer component={Paper} elevation={2} sx={{ borderRadius: 2 }}>
                <Table size="small" stickyHeader>
                    <TableHead>
                        <TableRow>
                            {adminTae && <StyledHeaderCell>Emisor NIT</StyledHeaderCell>}
                            <StyledHeaderCell>Tipo Documento</StyledHeaderCell>
                            <StyledHeaderCell align="center">Documento</StyledHeaderCell>
                            <StyledHeaderCell align="center">Fecha Emisión</StyledHeaderCell>
                            <StyledHeaderCell align="center">Cliente NIT</StyledHeaderCell>
                            <StyledHeaderCell align="right">Subtotal</StyledHeaderCell>
                            <StyledHeaderCell align="right">Total</StyledHeaderCell>
                            <StyledHeaderCell align="center">CUFE</StyledHeaderCell>
                            <StyledHeaderCell align="center">Ambiente</StyledHeaderCell>
                            <StyledHeaderCell align="center">Estado</StyledHeaderCell>
                            <StyledHeaderCell align="center">Acciones</StyledHeaderCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {documents.length === 0 ? (
                            <TableRow>
                                <StyledCell colSpan={adminTae ? 11 : 10} align="center"
                                    sx={{ color: '#9ca3af', py: 4 }}>
                                    Sin resultados. Aplica los filtros y presiona Buscar.
                                </StyledCell>
                            </TableRow>
                        ) : (
                            documents.map((item, key) => (
                                <StyledRow key={key} index={key}>
                                    {adminTae && <StyledCell>{item.emisor_Nit}</StyledCell>}
                                    <StyledCell>{item.typeDocument}</StyledCell>
                                    <StyledCell align="center">
                                        {item.typeDocument_Prefix} - {item.consecutive}
                                    </StyledCell>
                                    <StyledCell align="center">
                                        {moment(item.dateTime_Emision).format('DD/MM/YYYY HH:mm')}
                                    </StyledCell>
                                    <StyledCell align="center">{item.client_Nit}</StyledCell>
                                    <StyledCell align="right">
                                        <NumericFormat displayType="text" thousandSeparator="," value={item.subtotal} />
                                    </StyledCell>
                                    <StyledCell align="right">
                                        <NumericFormat displayType="text" thousandSeparator="," value={item.total} />
                                    </StyledCell>
                                    <StyledCell align="center" sx={{ maxWidth: 120 }}>
                                        <Tooltip title={item.cufe} arrow>
                                            <Typography variant="caption"
                                                sx={{ display: 'block', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: 110, cursor: 'default' }}>
                                                {item.cufe}
                                            </Typography>
                                        </Tooltip>
                                    </StyledCell>
                                    <StyledCell align="center">
                                        {item.typeEnviroment === 1
                                            ? <Chip label="Producción" size="small"
                                                sx={{ bgcolor: '#e0f0fb', color: '#224B6A', fontWeight: 600, fontSize: '0.7rem' }} />
                                            : <Chip label="Prueba" size="small"
                                                sx={{ bgcolor: '#f1f1f1', color: '#6b7280', fontSize: '0.7rem' }} />
                                        }
                                    </StyledCell>
                                    <StyledCell align="center">
                                        {item.stateDocument === 1
                                            ? <Chip label="Aceptado" size="small"
                                                sx={{ bgcolor: '#dcfce7', color: '#166534', fontWeight: 600, fontSize: '0.7rem' }} />
                                            : <Chip label="Rechazado" size="small"
                                                sx={{ bgcolor: '#fee2e2', color: '#991b1b', fontWeight: 600, fontSize: '0.7rem' }} />
                                        }
                                    </StyledCell>
                                    <StyledCell align="center">
                                        <Box sx={{ display: 'flex', justifyContent: 'center', gap: 0.5 }}>
                                            <DownloadMenu
                                                onDownload={(tipo) => descargarArhivo(
                                                    item.documentId,
                                                    item.typeDocument_Prefix + ' - ' + item.consecutive,
                                                    tipo
                                                )}
                                            />
                                            <Tooltip title="Reenviar documento">
                                                <IconButton size="small"
                                                    sx={{ color: '#1976d2' }}
                                                    onClick={() => { setModalReEnvio(true); setDocumentSelect(item); }}>
                                                    <BsFillSendFill size={14} />
                                                </IconButton>
                                            </Tooltip>
                                            <Tooltip title="Ver información de emisión">
                                                <IconButton size="small"
                                                    sx={{ color: '#6b7280' }}
                                                    onClick={() => { setModalInfoEmision(true); setDocumentSelect(item); }}>
                                                    <FaInfoCircle size={14} />
                                                </IconButton>
                                            </Tooltip>
                                        </Box>
                                    </StyledCell>
                                </StyledRow>
                            ))
                        )}
                    </TableBody>
                </Table>
            </TableContainer>

            <DocumentoReEnvioCorreo
                Show={modalReEnvio}
                cerrarModal={() => { setModalReEnvio(false); setDocumentSelect({}); }}
                DocumentSelect={documentSelect}
            />
            <DocumentoEnviadoInfoDIAN
                Show={modalInfoEmision}
                cerrarModal={() => { setModalInfoEmision(false); setDocumentSelect({}); }}
                DocumentSelect={documentSelect}
            />
        </Box>
    );
}

export default DocumentoEnviado;
